var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXpt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 135.999,
    height: 135.999,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3598.32 3598.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .str0{stroke:#000;stroke-width:17.64;stroke-miterlimit:22.9256}.fil1{fill:#fff}\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2579731218736"
  }, /*#__PURE__*/React.createElement("path", {
    className: "str0",
    style: {
      fill: "#000"
    },
    d: "M-.01 0h3598.33v3598.33H-.01z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1516.48 2011.35H496.35L277.73 3165.77H1735.1zM3141.57 2011.35H2121.44l-218.62 1154.42h1457.37zM2103.73 601.93H1083.6L864.98 1756.35h1457.37zM2867.85 303.09l96.65 299.44 314.66-.6-254.92 184.46 97.81 299.07-254.2-185.44-254.21 185.44 97.81-299.07-254.92-184.46 314.66.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpt);
export default __webpack_public_path__ + "static/media/XPT.ea33a5f38653f2be33312ce17de962b8.svg";
export { ForwardRef as ReactComponent };